import { api } from './client.js';

/** bankcard_manage_list 의 컬럼 그대로. */
export interface RecurringEditBody {
  pay_name: string;
  pay_cycle: string;
  pay_day: string;
  pay_type: string;
  amount: string | number;
  amount_us?: string | number;
  bankcode?: string | number;
  banksn?: string;
  bankinname?: string;
  cardcom?: string;
  use_area?: number;
  up_name: string;
  use_status?: number;
  memo?: string;
  /** 마지막 결제일 - 수정에서만 보낸다(등록 폼에는 없다). */
  last_pay_day?: string;
}

/** corp(법인)는 등록할 때만 정해진다 - 입금건·카드건과 같다. */
export interface RecurringCreateBody extends RecurringEditBody {
  corp: string;
}

/**
 * 목록 조회는 그대로 정의 기반 화면(report.registry.ts 의 payment-recurring)을
 * 쓴다. 여기서는 등록·수정(입금건의 paymentBankApi.create/update, 카드건의
 * paymentCardApi 와 같은 자리)만 감싼다.
 */
export const paymentRecurringApi = {
  create: (body: RecurringCreateBody) => api.post<{ seq: string }>('/payment/recurring', body),

  update: (seq: number, body: RecurringEditBody) => api.patch(`/payment/recurring/${seq}`, body),

  /** 소프트 삭제 - 입금건(paymentBankApi.remove)과 같다. */
  remove: (seq: number) => api.del(`/payment/recurring/${seq}`),
};
